import { Component } from '@angular/core';
import { BaseComponent } from "../common/base-component";
import { BankAccountService } from "./bank-account-service";
import { ModalService } from "./../services/modal-service";
import { MessageService } from "../services/message-service";
import { ActivatedRoute } from '@angular/router';
import {
    FormGroup,
    FormControl
} from '@angular/forms';

@Component({
    selector: 'dk-bank-account-list',
    template: require('./bank-account-list.html'),
    providers: [BankAccountService]
})

export class BankAccountListComponent extends BaseComponent {
    public accounts: any[];
    public isInEdit: boolean = false;
    public editedId: number = null;
    private ownerId: number = null;
    smsMode: boolean;
    private deleteIdToConfirm: number;

    constructor(private bankAccountService: BankAccountService,
        private modalService: ModalService,
        private messageService: MessageService,
        private route: ActivatedRoute) {
        super();
    }

    form: FormGroup = new FormGroup({
        SmsCode: new FormControl('')
    });

    load() {
        this.bankAccountService.accounts(this.ownerId).subscribe(accounts => {
            this.accounts = accounts;
        });
    }

    ngOnInit(): void {
        this.ownerId = this.route.snapshot.params['ownerId'];

        if (this.route.snapshot.params['add']) {
            this.edit(null);
        }

        this.load();
    }

    cancel() {
        this.isInEdit = false;
        this.load();
    }

    saved() {
        this.isInEdit = false;
        this.ownerId = null;
        this.load();
    }

    edit(id: number): void {
        this.isInEdit = false;
        this.editedId = id;
        this.isInEdit = true;
    }

    back() {
        this.smsMode = false;
    }

    delete(id: number): void {
        this.modalService.confirm().then(result => {
            if (result) {
                this.bankAccountService.deleteValidation(id).subscribe(() => {
                    this.bankAccountService.isAccountBankCodeChangeLocked().subscribe(isLocked => {
                        if (isLocked) {
                            this.smsMode = true;
                            this.deleteIdToConfirm = id;
                            this.modalService.sendSmsCode();
                            this.form.controls['SmsCode'].setValue('');
                            return;
                        }
                        else {
                            this.bankAccountService.delete(id).subscribe(() => {
                                this.messageService.deleted();
                                this.load();
                            }, error => {
                                this.messageService.errorByMessageId(error.messageId);
                            });
                        }
                    })
                }, error => {
                    this.messageService.errorByMessageId(error.messageId);
                });
            }
        });
    }

    deleteWithSms() {
        this.bankAccountService.deleteValidation(this.deleteIdToConfirm).subscribe(() => {
            let code = this.form.controls['SmsCode'].value;
            this.bankAccountService.delete(this.deleteIdToConfirm, code).subscribe(() => {
                this.messageService.deleted();
                this.load();
                this.smsMode = false;
                this.form.controls['SmsCode'].setValue('');
            }, error => {
                this.messageService.errorByMessageId(error.messageId);
                this.smsMode = false;
                this.form.controls['SmsCode'].setValue('');
            });
        }, error => {
            this.messageService.errorByMessageId(error.messageId);
            this.smsMode = false;
            this.form.controls['SmsCode'].setValue('');
        });
    }
}
